import { FC } from 'react'

import { Icon } from './types'

export const FightIcon: FC<Icon> = ({ className }) => {
  return (
    <svg width="35" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g filter="url(#filter0_d_54_801)">
        <path
          d="M8.41509 11.2245L6.80707 12.8705L5.9408 12.0256C5.84756 11.9347 5.69626 11.9347 5.60331 12.0256L5.16296 12.4551C5.06971 12.546 5.06971 12.6936 5.16296 12.7842L6.45906 14.0483L5.63309 15.0653C5.59038 15.0618 5.54947 15.0527 5.50586 15.0527C4.67147 15.0527 3.995 15.7125 3.995 16.5262C3.995 17.34 4.67147 17.9997 5.50586 17.9997C6.34025 17.9997 7.01672 17.34 7.01672 16.5262C7.01672 16.4769 7.0068 16.4306 7.00198 16.3825L8.04512 15.5948L9.48019 16.9944C9.57343 17.0853 9.72473 17.0853 9.81767 16.9944L10.258 16.5649C10.3513 16.474 10.3513 16.3264 10.258 16.2358L9.26061 15.263L11.059 13.6279L8.41509 11.2245Z"
          fill="currentColor"
        />
        <path
          d="M17.4944 15.0533C17.4508 15.0533 17.4099 15.0624 17.3672 15.0659L16.5412 14.0486L17.8373 12.7845C17.9306 12.6936 17.9306 12.546 17.8373 12.4554L17.397 12.0259C17.3503 11.9804 17.2893 11.9579 17.2282 11.9579C17.1672 11.9579 17.1061 11.9804 17.0595 12.0259L16.1932 12.8708L4.40647 0.805541C4.27322 0.669133 4.08012 0.594035 3.83858 0.584355L0.571411 0L1.02199 3.36151C1.03463 3.59707 1.11373 3.78452 1.2551 3.91301L13.7397 15.263L12.7422 16.2358C12.649 16.3267 12.649 16.4743 12.7422 16.5649L13.1826 16.9944C13.2292 17.0399 13.2903 17.0625 13.3513 17.0625C13.4124 17.0625 13.4735 17.0399 13.5201 16.9944L14.9551 15.5948L15.9983 16.3828C15.9935 16.4309 15.9835 16.4772 15.9835 16.5265C15.9835 17.3403 16.66 18 17.4944 18C18.3288 18 19.0053 17.3403 19.0053 16.5265C19.0053 15.7127 18.3288 15.0533 17.4944 15.0533Z"
          fill="currentColor"
        />
        <path
          d="M19.1614 0.584355C18.9198 0.594035 18.7264 0.669133 18.5935 0.805541L11.9153 7.6412L14.6098 10.3996L21.7448 3.91301C21.8862 3.78452 21.9653 3.59707 21.9779 3.36151L22.4285 0L19.1614 0.584355Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_54_801"
          x="0.571411"
          y="0"
          width="21.8571"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.109804 0 0 0 0 0.156863 0 0 0 0 0.34902 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_801" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_801" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
